import QuestionList from "components/questions/QuestionList";
import { HEADING_TYPES } from "components/shared/Heading";
import Separator from "components/shared/Separator";
import Title from "components/shared/Title";

const mainClass = "help-question-wall";

const QuestionWall = ({ module }) => {
	return module ? (
		<div className={`${mainClass}__container`}>
			<Title headingType={HEADING_TYPES.h2} title={module.name} />
			<Separator />
			<QuestionList questions={module.questions} />
		</div>
	) : null;
};

export default QuestionWall;
